/**
 * Dependencies
 */
import { cloneDeep } from 'lodash'

/**
 * State Definition
 *
 * @type {Object}
 */
const state = {
    loading: false,
    errors: [],
    collateral: [],
    editing: null,
    uploadingContext: null,
    showFormModal: false,
    showUploadModal: false
}

/**
 * Return a state copy
 *
 * @return {Object}
 */
export const getState = () => cloneDeep(state)

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/debt-servicing/state.js